// Cliente do Measurement Pixel do ChatGPT Ads (OpenAI Ads).
// Doc: https://developers.openai.com/ads/measurement-pixel

type OaiqQueue = {
	(...args: unknown[]): void;
	q?: IArguments[];
};

declare global {
	interface Window {
		oaiq?: OaiqQueue;
	}
}

export const OPENAI_ADS_SDK_URL = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';

type MeasureOptions = {
	// Mesmo id no evento do browser e no da Conversions API = um evento só.
	event_id?: string;
	// Obrigatório quando o evento é 'custom'.
	custom_event_name?: string;
	opt_out?: boolean;
};

// O snippet de init cria a fila em window.oaiq antes do SDK carregar, então medir
// é seguro desde o primeiro instante — só não antes do snippet rodar (ver index.tsx).
export function measure(eventName: string, eventData: Record<string, unknown>, options?: MeasureOptions) {
	if (typeof window === 'undefined' || typeof window.oaiq !== 'function') {
		return;
	}

	if (options) {
		window.oaiq('measure', eventName, eventData, options);
		return;
	}

	window.oaiq('measure', eventName, eventData);
}

export function measurePageView(path: string, title?: string) {
	measure('page_viewed', {
		type: 'contents',
		contents: [{ id: path, name: title || path, content_type: 'page' }],
	});
}

// Conversões (task #4630). Eventos padrão só existem para os dois primeiros; para
// candidatura e cadastro de empresa usamos evento customizado, porque o schema de
// lead_created (customer_action) não aceita nada que distinga um do outro no relatório.
export function measureLeadCreated() {
	measure('lead_created', { type: 'customer_action' });
}

export function measureRegistrationCompleted() {
	measure('registration_completed', { type: 'customer_action' });
}

export function measureCustomEvent(name: string, eventData: Record<string, unknown> = {}) {
	measure('custom', { type: 'custom', ...eventData }, { custom_event_name: name });
}

const ONCE_KEY_PREFIX = 'incluipcd-oaiq-';

// Para conversões medidas na montagem de uma tela (e não num submit): sem isso, um
// F5 ou uma volta à mesma tela contariam de novo. Vale pela aba (sessionStorage).
export function measureOnce(key: string, send: () => void) {
	try {
		const storageKey = `${ONCE_KEY_PREFIX}${key}`;

		if (window.sessionStorage.getItem(storageKey)) {
			return;
		}

		window.sessionStorage.setItem(storageKey, '1');
	} catch {
		// sessionStorage indisponível: medir sem dedup é melhor que não medir
	}

	send();
}
